/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_Ocr_AcInputs */

const en_pc_cmp_r_ocr_ac = /** @type {(inputs: Pc_Cmp_R_Ocr_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Many languages`)
};

const zh_pc_cmp_r_ocr_ac = /** @type {(inputs: Pc_Cmp_R_Ocr_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`多种语言`)
};

/**
* | output |
* | --- |
* | "Many languages" |
*
* @param {Pc_Cmp_R_Ocr_AcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_ocr_ac = /** @type {((inputs?: Pc_Cmp_R_Ocr_AcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_Ocr_AcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_ocr_ac(inputs)
	return zh_pc_cmp_r_ocr_ac(inputs)
});
export { pc_cmp_r_ocr_ac as "pc.cmp.r.ocr.ac" }